module.exports = __webpack_public_path__ + "img/zoom.ae377d95.svg";